import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mcb-bread-crumb',
  templateUrl: './bread-crumb.component.html'
})
export class BreadCrumbComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
